import { useSelector } from "react-redux";
import { DataGrid } from "../../components"
import { getLocalized } from "../../redux/localization";
import { adminSSSUrl } from "../../services/urls"
import adminCreateSSSForm from "./create";
import AdminSSSDetailPage from "./detail"
import adminEditSSSForm from "./edit";

const SSSPage = () => {
    const localize = useSelector(getLocalized);

    const columns = [
        {
            dataField: "Question",
            caption: localize.getString("question")
        },
        {
            dataField: "Answer",
            caption: localize.getString("answer")
        }
    ]

    return <DataGrid
        url={adminSSSUrl}
        getByIdUrl={adminSSSUrl}
        columns={columns}
        refObject={{}}
        title="Sıkça Sorulan Sorular"
        details={{
            width: "40%",
            height: "40%",
            getByIdUrl: adminSSSUrl,
            title: localize.getString("sssDetail"),
            component: AdminSSSDetailPage,

        }}
        create={{
            createUrl: adminSSSUrl,
            component: adminCreateSSSForm,
            width: "40%",
            height: "40%",
            title: localize.getString("createSSS")
        }}
        edit={{
            editUrl: adminSSSUrl,
            component: adminEditSSSForm,
            width: "40%",
            height: "40%",
            title: localize.getString("editSSS")
        }}
        remove={{
            url: adminSSSUrl
        }}
    />


}

export default SSSPage;